<template>
    <div class="widget-map map" id="widgetMap">
        <div class="absolute bottom-2 right-2 z-1">
            <UiSwitch
                v-model="displayMapVecto"
                :labelYes="$t('plans.mapstyles.vecto')"
                :labelNo="$t('plans.mapstyles.sat')"
                style="width: 200px; box-shadow: var(--shadows-base);"
            />
        </div>
        <div class="geo-authorization" v-if="hasPrivacyOption">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          <span>{{ $t("home.widgets.map.privacy_option_warning") }}</span>
        </div>
        <div class="geo-authorization" v-else-if="!hasLocationVisibility">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          <span>{{ $t("home.widgets.map.location_disabled_role") }}</span>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import {EventBus} from '@/components/dashboard/eventbus/EventBus';
    import ToMap from '@/components/dashboard/transformers/ToMap';
    import {Map} from '@/components/plans/map/MapClass';
    import MapUtils from '@/services/map.js';
    import mapboxgl from 'mapbox-gl';
    import Btn from '@/components/ui/Button';
    import UiSwitch from '@/components/ui/Switch';
    import Auth from '@/services/auth.js';

    import iconIcatSrc from '@/assets/img/iconIcat.svg';
    import {useDvFlagAccess} from "../../../services/featureFlag";

    // https://fr.wikipedia.org/wiki/Centre_de_la_France#Centre_du_cercle_minimum
    // 46° 36′ 22″ N, 1° 52′ 31″ E
    const CENTER_FRANCE_SMALLEST_CIRCLE = [1.875278, 46.606111];

    export default {
        components: {
          useDvFlagAccess,
            Btn,
            UiSwitch,
        },
        computed: {
          hasLocationVisibility() {
            return useDvFlagAccess("beepiz-dashboard-geolocalisation-can:read")
          },
          hasPrivacyOption() {
            return useDvFlagAccess("beepiz-privacy-mode-can:read")
          },
          displayMapStyle: function(){
            return this.mapStyles[this.displayMapVecto ? 0 : 1];
          }
        },
        data() {
            return {
                map: null,
                firstTime: true,
                markers: {},
                accuracies: [],
                coordinates: [],
                selectedMarker: null,
                mapStyles: [
                    'mapbox://styles/mapbox/streets-v12',
                    'mapbox://styles/mapbox/satellite-streets-v12'
                ],
                displayMapVecto: true,
            }
        },
        destroyed: function () {
            EventBus.$off();
        },
        methods: {
            mapLoaded: function (e) {
                //this.isMapLoaded = true;
                this.map._map.addLayer({
                    'id': 'accuracy',
                    'type': 'circle',
                    'source': this.accuracies,
                    'paint': {
                        // make circles larger as the user zooms from z12 to z22
                        'circle-radius': {
                            'stops': [
                                [0, 0],
                                [22, 150]
                            ]
                        },
                        // color circles by ethnicity, using a match expression
                        // https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
                        'circle-color': '#FFCC00'
                    }
                });
            },
            addMarkers: function (data) {
                this.coordinates = [];

                var itemData = {};
                for (var i = 0; i < data.features.length; i++) {
                    itemData = data.features[i];

                    if(
                        //si le datis n'est pas en alerte
                        !(itemData.properties.alerts && itemData.properties.alerts.length > 0) &&
                        //Si j'ai le hasPrivacyOption ou que je n'ai pas le bon role
                        (this.hasPrivacyOption || !this.hasLocationVisibility)
                    ) continue



                    this.coordinates.push([itemData.geometry.coordinates[1], itemData.geometry.coordinates[0]]);
                    var popup = new mapboxgl.Popup()
                        .setHTML('<span>' + itemData.properties.dati.name + '</span>')
                        .on('close', popupI => {
                            this.selectedMarker = null;
                        });


                    if(window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_GPS_ACCURACY') === '1' || window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_GPS_ACCURACY') == null) {
                        this.accuracies.push(this.createGeoJSONCircle([parseFloat(itemData.geometry.coordinates[1]), parseFloat(itemData.geometry.coordinates[0])], itemData.properties.gps_accuracy / 1000))
                    }

                    var alertClass=''
                    let customIcon = null

                    if(itemData.properties.alerts && itemData.properties.alerts.length > 0) {
                        if (itemData.properties.alerts[0].event_type_icon == "beepiz-catsafe-icat01") {
                            customIcon = iconIcatSrc
                        } else {
                            alertClass=itemData.properties.alerts[0].event_type_icon
                        }
                    }
                    else if(itemData.properties.offline_zone_deadline){
                        alertClass='beepiz-offline-zone-in'
                    }

                    //WIP ADD AVATARS
                    let markerUser = require('@/assets/img/user-no-img.png')

                    /*if(true) {
                        markerUser = 'https://robohash.org/2681738c506ddbc1f73df31527467115?set=set4&bgset=&size=400x400'
                    }*/

                    var marker = this.map.addHTMLMarker(
                        {
                            type: 'img',
                            value: itemData.properties.identification ? (itemData.properties.identification.picture ? itemData.properties.identification.picture : markerUser) : markerUser,
                            icon: customIcon
                        },
                        itemData.geometry.coordinates[0],
                        itemData.geometry.coordinates[1],
                        'marker-widget ' + itemData.properties.spClass + ' ' + alertClass,//itemData.properties.datiState.alert === true ? 'alert-animate' : null,
                        popup
                    );

                    this.markers[itemData.properties.id] = marker;
                }


            },
            initMarkers: function (event) {
                if (event.source == this.source.name) {

                    EventBus.$off('source-ready', this.initMarkers);

                    var sourceName = this.source.name;
                    var data = ToMap[sourceName](event.data);

                    this.addMarkers(data);
                }
            },
            setStyle: function (isVecto) {
                var that = this;
                this.map._map.setStyle(this.mapStyles[isVecto ? 0 : 1]);
                this.map._map.on('style.load', function() {
                    that.map.initLayers();
                });
            },
            metersToPixelsAtMaxZoom(meters, latitude) {
                return meters / 0.075 / Math.cos(latitude * Math.PI / 180)
            },

            createGeoJSONCircle(center, radiusInKm, points) {
                if (!points) points = 64;

                var coords = {
                    latitude: center[1],
                    longitude: center[0]
                };

                var km = radiusInKm;

                var ret = [];
                var distanceX = km / (111.320 * Math.cos(coords.latitude * Math.PI / 180));
                var distanceY = km / 110.574;

                var theta, x, y;
                for (var i = 0; i < points; i++) {
                    theta = (i / points) * (2 * Math.PI);
                    x = distanceX * Math.cos(theta);
                    y = distanceY * Math.sin(theta);

                    ret.push([coords.longitude + x, coords.latitude + y]);
                }
                ret.push(ret[0]);

                return {

                    "type": "Feature",
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [ret]
                    }

                };
            }
        },
        mounted: function () {

            EventBus.$on('source-ready', this.initMarkers);

            var mapConfig =
                {
                    logoPosition: 'top-left',
                    attributionControl: false,
                    style: 'mapbox://styles/mapbox/streets-v12',
                    center: CENTER_FRANCE_SMALLEST_CIRCLE,
                    zoom: 3,
                };
            var map = new Map('widgetMap', mapConfig, () => {
                this.map._map.resize();
                if (this.firstTime) {

                    if (this.coordinates.length > 0) {
                        if (this.coordinates.length == 1) {
                            this.map._map.flyTo({center: this.coordinates[0], zoom: 17, speed: 2});
                        } else {
                            this.map._map.fitBounds(MapUtils.getBounds(this.coordinates, 0.1));
                        }
                        this.firstTime = false;
                    }
                }

                this.map._map.addSource("source_circle_500", {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": this.accuracies
                    }
                });

                this.map._map.addLayer({
                    'id': 'accuracy',
                    'type': 'fill',
                    'source': 'source_circle_500',
                    'paint': {
// make circles larger as the user zooms from z12 to z22


                        'fill-color': '#ffc107',
                        'fill-opacity': 0.2,
                        'fill-outline-color':'#ffc107'
                    }
                });

                EventBus.$on('source-ready', event => {
                    if (event.source == this.source.name) {

                        var sourceName = this.source.name;


                        if (sourceName != null) {

                            this.accuracies = []
                            this.map.removeHTMLMarkers();


                            //this.map.addGeoJson(ToMap[event.source](event.data))
                            var data = ToMap[sourceName](event.data);

                            this.addMarkers(data);

                            if (this.selectedMarker != null) {
                                this.markers[this.selectedMarker].togglePopup();
                            }

                        }


                    }


                });

                EventBus.$on('list-dati-click', event => {
                    if (this.markers[event.key]) {
                        this.map._map.flyTo({center: this.markers[event.key].getLngLat(), zoom: 17, speed: 2});
                        this.markers[event.key].togglePopup();
                        this.selectedMarker = event.key;
                    }

                });
            });

            this.map = map;


        },
        name: '',
        props: {
            source: {
                type: Object,
                required: true
            },
            resize: {
                type: Boolean,
                default: false
            }
        },
        updated: function () {

        },
        watch: {
            resize: function (newValue) {

                var interval = setInterval(() => {
                    this.map._map.resize();
                }, 10);

                setTimeout(() => {
                    clearInterval(interval);
                    this.map._map.resize();
                }, 1000);


            },

            accuracies(){

                    if (this.map._map.getSource("source_circle_500")) {
                        this.map._map.getSource("source_circle_500").setData({

                                "type": "FeatureCollection",
                                "features": this.accuracies
                            }
                        );
                    }

            },
            displayMapVecto: function(newValue){
                this.setStyle(newValue);
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
